import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Divider,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import { lowerCase, upperCase } from "lodash";
import { useTheme } from "@mui/system";
import CustomButton from "../CustomButton";
import cssVariables from "../../utils/cssVariables";
import { COLORS } from "../../constants";
import { formatDisplayName } from "../../utils/helpers";

const BottombarShopByCategoryDrawer = ({
  categoriesAndTypes,
  mobileCategoriesDrawerOpen,
  mobileTypesDrawerOpen,
  categoryToDisplay,
  toggleCategories,
  toggleTypes,
  handleCategoryClick,
  handleCloseTypesClick,
}) => {
  const theme = useTheme();
  const sortedCategories = [...categoriesAndTypes].sort((a, b) =>
    a.productCategoryName.localeCompare(b.productCategoryName)
  );

  return (
    <Drawer
      anchor="top"
      open={mobileCategoriesDrawerOpen || mobileTypesDrawerOpen}
      onClose={() => {
        if (categoryToDisplay) handleCloseTypesClick();
        else toggleCategories();
      }}
      sx={{
        width: "100%",
        "& .MuiDrawer-paper": {
          width: "100%",
          height: "100vh",
          boxSizing: "border-box",
          backgroundColor: `${COLORS.background} !important`,
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          borderRadius: 0,

          borderBottom: `1px solid ${COLORS.border}`,
          justifyContent: "center",
          position: "relative",
          "& > *:first-child": { position: "absolute", left: 0 },
          "& > *:last-child": { position: "absolute", right: 0 },

          width: "100%",
          marginBottom: "1rem",
          position: "sticky",
          top: 0,
          zIndex: 1100,
          boxShadow: "none",
          backgroundColor: COLORS.white,
        }}
      >
        {categoryToDisplay ? (
          <Box
            sx={{
              alignItems: "left",
              ml: 1,
              borderRadius: "2px",
              backgroundColor: `${COLORS.themeRed} !important`,
            }}
            onClick={handleCloseTypesClick}
          >
            <IconButton>
              <ChevronLeftIcon fontSize="small" sx={{ color: COLORS.white }} />
            </IconButton>
          </Box>
        ) : (
          <Box />
        )}
        <Box
          sx={{
            textAlign: "center",
            padding: 2,
            flexGrow: 1,
            borderRadius: 0,
            boxShadow: "none !important",
          }}
        >
          <Typography sx={{ fontSize: "var(--font-size-xs)", fontWeight: 500 }}>
            Shop by Category
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: `${COLORS.themeRed} !important`,
            mr: 1,
            borderRadius: "2px",
          }}
        >
          <IconButton
            onClick={() => {
              if (categoryToDisplay) handleCloseTypesClick();
              else toggleCategories();
            }}
            sx={{ color: COLORS.white }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Stack>
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        {!categoryToDisplay ? (
          <Paper
            sx={{
              width: "100%",
              flexGrow: 1,
              overflowY: "auto",
              borderRadius: 0,
              boxShadow: "none",
              mt: 2,
            }}
          >
            <List
              sx={{
                py: `0 !important`,
              }}
            >
              {sortedCategories.map((category, i) => {
                const categoryName = formatDisplayName(category.productCategoryName);

                return (
                  <div key={i}>
                    <ListItemButton
                      href="#"
                      onClick={() => handleCategoryClick(category)}
                      sx={{
                        borderBottom: `1px solid ${COLORS.background}`,
                        "& .MuiTypography-root": {
                          fontSize: "var(--font-size-xxs)",
                        },
                      }}
                    >
                      <ListItemText primary={categoryName} />
                      <IconButton sx={{ flexShrink: 0 }} edge="end">
                        <ArrowForwardIcon fontSize="small" />
                      </IconButton>
                    </ListItemButton>
                  </div>
                );
              })}
            </List>
          </Paper>
        ) : (
          <>
            <Typography
              sx={{
                mb: 2,
                mx: 2,
                color: COLORS.gray,
                fontSize: "var(--font-size-s)",
                fontWeight: 400,
              }}
            >
              {formatDisplayName(categoryToDisplay.productCategoryName)}
            </Typography>
            <Paper
              sx={{
                width: "100%",
                flexGrow: 1,
                overflowY: "auto",
                borderRadius: 0,
                boxShadow: "none",
              }}
            >
              <List
                sx={{
                  py: `0 !important`,
                }}
              >
                {[...categoryToDisplay.productTypes].sort((a, b) => a.name.localeCompare(b.name)).map((type, i) => {
                  let typeName;
                  let typeSlug;
                  if (lowerCase(type.name) === "view all") {
                    typeName = upperCase(type.name);
                    typeSlug = `/products/${categoryToDisplay.productCategoryId}`;
                  } else {
                    typeName = formatDisplayName(type.name);
                    typeSlug = `/products/${categoryToDisplay.productCategoryId}/${type.productTypeId}`;
                  }

                  return (
                    <div key={i}>
                      <ListItemButton
                        href={typeSlug}
                        sx={{
                          borderBottom: `1px solid ${COLORS.background}`,
                          "& .MuiTypography-root": {
                            fontSize: "var(--font-size-xxs)",
                          },
                        }}
                      >
                        <ListItemText primary={typeName} />
                      </ListItemButton>
                    </div>
                  );
                })}
              </List>
            </Paper>
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default BottombarShopByCategoryDrawer;
